import React from 'react';
import RsvpService from '../../../../services/RsvpService';
import WebinarService from '../../../../services/Webinar';
import HtmlWrapper from '../../../HtmlWrapper';

export const openWebinarUrl = (session, time) => {
    const url           = session.webinar_url;
    const description   = session.webinar_description;
    const isOnline      = RsvpService.isOnline(session)
    const hasPassed     = RsvpService.hasEventPassed(time);
    WebinarService.openModal(url, description, isOnline, hasPassed);
}

export function WebinarUrl({url}) {
    if (url && typeof url === 'string') {
        let displayUrl = url.length > 80 ? `${url.slice(0, 80)}...` : url;
        return (
            <a href={url} target="_blank">
                {displayUrl}
            </a>
        );
    }
    return null;
}

export function WebinarDescription({description}) {
    if (description) {
        return (
            <HtmlWrapper html={description} />
        );
    } 
    return null;
}

export default {
    openWebinarUrl,
    WebinarUrl,
    WebinarDescription
};